import React, { useState } from 'react';
import './index.less';
import classNames from 'classnames';

export enum TabsEnum {
  /**
   * 流程
   */
  Process = 'Process',
  /**
   * 进度
   */
  Progress = 'Progress',
}

const list = [
  {
    label: '流程信息',
    key: TabsEnum.Process,
  },
  {
    label: '状态进度',
    key: TabsEnum.Progress,
  },
];

const Tabs = (props: any) => {
  const { onChange } = props;
  const prefixClx = 'bidding-detail-tabs';

  const [indexKey, setIndexKey] = useState(list[0].key);

  const handleSelect = (key: TabsEnum) => {
    setIndexKey(key);
    onChange && onChange(key);
  };

  return (
    <div className={`${prefixClx}`}>
      {list.map((v) => (
        <div
          key={v.key}
          className={classNames(`${prefixClx}-tab`, {
            active: indexKey === v.key,
          })}
          onClick={() => handleSelect(v.key)}
        >
          {v.label}
        </div>
      ))}
    </div>
  );
};

export default Tabs;
